import SinglePage from "./components/SinglePage/SinglePage";
import PopupPage from "./components/PopupPage/PopupPage";
import Script from 'react-load-script';
import LoadingBrickPopup from './components/LoadingBrick/LoadingBrickPopup'
import EditCardInfoPopup from './components/EditCardInfoPopup/EditCardInfoPopup'
import {useDispatch, useSelector} from "react-redux";
import useLocalStore from './hooks/useLocalStore'

const AppContent = () => {
    useLocalStore()
    let dispatch = useDispatch()
    let handleScriptErrorStripe = () => {
        console.log('script err')
    }
    let handleScriptLoadStripe = () => {
        console.log('script load')
    }
    let handleScriptErrorPaypal = () => {
        console.log('Paypal err')
    }
    let handleScriptLoadPaypal = () => {
        console.log('Paypal load')
    }
    let {show, isEditCardInfo, cardParams, loading, method} = useSelector(state => {
        return {
            show: state.mainReducer.show,
            isEditCardInfo: state.mainReducer.isEditCardInfo,
            cardParams: state.mainReducer.cardParams,
            loading: state.mainReducer.loading,
            method: state.mainReducer.method,
        }
    })

    // let id = 'AZH2mpn68AVbZ71MGdaAlZ1pkbk-AI8I_x2OK1MVIb0BMM8X9AXgfNnX-2wsbGplWRVTszWkJNQ2wFDD'
    let id = window.FJGlobalariable.modSubscription.config.clientId
    let url = "https://www.paypal.com/sdk/js?client-id=" + id + "&vault=true&intent=subscription&disable-funding=credit,card"
    return (
        <div>
            {
                show &&
                <>
                    {method === 'popup' && <PopupPage/>}
                    {method !== 'popup' && <SinglePage/>}
                    <Script
                        url="https://js.stripe.com/v2/"
                        onError={handleScriptErrorStripe}
                        onLoad={handleScriptLoadStripe}
                    />
                    {/*<FJScript*/}
                    {/*	name='paypal'*/}
                    {/*	url={url}*/}
                    {/*/>*/}

                    {/* 以下为弹窗 */}
                    {loading && <LoadingBrickPopup/>}
                    {isEditCardInfo && <EditCardInfoPopup cardParams={cardParams}/>}
                </>
            }
            {
                isEditCardInfo && cardParams &&
                <>
                    <Script
                        url="https://js.stripe.com/v2/"
                        onError={handleScriptErrorStripe}
                        onLoad={handleScriptLoadStripe}
                    />
                    {/*<FJScript*/}
                    {/*	name='paypal'*/}
                    {/*	url={url}*/}
                    {/*/>*/}
                    {loading && <LoadingBrickPopup/>}
                    <EditCardInfoPopup cardParams={cardParams}/>
                </>
            }
        </div>
    )
}
export default AppContent